import { ObjectType } from '../base';
import { GenericTranslation } from '../culture';
import { UserRelation } from '../user';

export enum CheckInInputType {
	Text = 1,
	TextArea = 2,
	Number = 3,
	Rating = 4,
}

export const DEFAULT_CHECKIN_RATING_OPTION_COUNT = 5;

export enum CheckInTiming {
	Before = 1,
	After = 2,
}

export type CheckInDefinitionObjectTypeLink = {
	id: number;
	checkInDefinitionId: number;
	objectType: ObjectType;
	subjectRole: string;
	respondentRole: string;
	active: boolean;
	deleted: boolean;
};

export type CheckInDefinition = {
	id: number;
	portalId: number;
	type: CheckInInputType;
	timing: CheckInTiming;
	order: number;
	ratingOptionCount: number;
	active: boolean;
	deleted: boolean;
	questionTranslations: GenericTranslation[];
	objectTypeLinks: CheckInDefinitionObjectTypeLink[];
};

export type CheckInResponse = {
	id?: number;
	checkInDefinitionId: number;
	objectType: ObjectType;
	objectId: number;
	subjectUserId: number;
	respondentUserId: number;
	value: string;
	deleted?: boolean;
};

export type SaveCheckInResponsesRequest = {
	objectType: ObjectType;
	objectId: number;
	responses: CheckInResponse[];
};

export type ResolvedCheckIn = {
	checkInDefinitionId: number;
	checkInDefinitionObjectTypeLinkId: number;
	objectType: ObjectType;
	objectId: number;
	subjectUserId: number;
	subjectUserName: string;
	respondentUserId: number;
	respondentRole: string;
	subjectRole: string;
	order: number;
	type: CheckInInputType;
	timing: CheckInTiming;
	ratingOptionCount: number;
	value: string;
	questionTranslations: GenericTranslation[];
	isEnabled: boolean;
	subjectUserRelations: UserRelation[];
};

export type CheckInRoleOption = {
	Id: string;
	Name: string;
};

export const checkInObjectTypeOptions = [{ Id: ObjectType.Event, Name: 'Event' }];

export const checkInInputTypeOptions = [
	{ Id: CheckInInputType.Text, Name: 'Text' },
	{ Id: CheckInInputType.TextArea, Name: 'Textarea' },
	{ Id: CheckInInputType.Number, Name: 'Number' },
	{ Id: CheckInInputType.Rating, Name: 'Rating' },
];

export const checkInTimingOptions = [
	{ Id: CheckInTiming.Before, Name: 'Before' },
	{ Id: CheckInTiming.After, Name: 'After' },
];

export const eventCheckInRoleOptions: CheckInRoleOption[] = [
	{ Id: 'Participant', Name: 'Participant' },
	{ Id: 'Organizer', Name: 'Organizer' },
	{ Id: 'CoOrganizer', Name: 'Co-organizer' },
	{ Id: 'OrganizerOrCoOrganizer', Name: 'Organizer or Co-organizer' },
];
